import { render, staticRenderFns } from "./BuffetUser.vue?vue&type=template&id=7d114bd2"
import script from "./BuffetUser.vue?vue&type=script&lang=js"
export * from "./BuffetUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports